const bridges = [
  {
    _id: "bridge-a15",
    code: "A15",
    name: "A15 Bridge",
    protocol: "ASTM",
    version: "1.0.0",
    releaseDate: "2026-06-19",
    status: "Available",
    fileName: "A15-bridge-portable.zip",
    fileType: "zip",
    downloadUrl:
      "/assets/bridges/A15/A15-bridge-portable.zip",
    description:
      "Portable middleware setup package for A15 analyzer connectivity and local bridge configuration.",
    notes: [
      "Extract the zip, then run 'A15 Bridge Setup.exe'.",
      "The package ships with a clean tenant.json so the setup wizard opens on first run.",
    ],
  },
  {
    _id: "bridge-hl7",
    code: "HL7",
    name: "HL7 Bridge",
    protocol: "HL7",
    version: "1.0.0",
    releaseDate: "2026-06-19",
    status: "Available",
    fileName: "HL7-bridge-readme.txt",
    fileType: "txt",
    description:
      "Generic HL7 bridge package for message exchange and integration testing.",
    notes: [
      "Static placeholder download for now.",
      "Replace with the production-ready bridge package later.",
    ],
  },
];

export default bridges;
